<template>
  <div class="maintenance-screen" role="alert" aria-live="assertive" data-testid="maintenance-screen">
    <div class="maintenance-card">
      <div class="maintenance-icon" aria-hidden="true">🛠️</div>
      <h1 class="maintenance-title">We'll be right back</h1>
      <p class="maintenance-message">{{ message }}</p>
    </div>
  </div>
</template>

<script>
import { maintenanceMessage } from '../../utils/maintenance'

export default {
  name: 'MaintenanceScreen',
  computed: {
    message() { return maintenanceMessage() }
  }
}
</script>

<style scoped>
.maintenance-screen {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: var(--background-color, #f9fafb);
  color: var(--text-color, #111827);
}
.maintenance-card {
  max-width: 32rem;
  text-align: center;
}
.maintenance-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}
.maintenance-title {
  font-size: 1.75rem;
  font-weight: 700;
  margin-bottom: 0.75rem;
}
.maintenance-message {
  font-size: 1rem;
  line-height: 1.6;
  color: var(--muted-text-color, #4b5563);
}
</style>
